<template>
  <div class="w-8 h-8">
    <img :src="source" :alt="name" />
  </div>
</template>
<script>
export default {
  props: {
    source: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
};
</script>
